import {Component, OnInit, ViewEncapsulation} from "@angular/core";
import {QuoteService} from "../../../_services/quote.service";
import {ActivatedRoute, RouterModule} from "@angular/router";
import {CommonModule, NgForOf} from "@angular/common";
import {PlanImage} from "src/app/_models/PlanImage";
import {Plan} from "../../../_models/Plan";
import {UrlService} from "../../../_services/url.service";

@Component({
  standalone: true,
  templateUrl: './view-plan-image.component.html',
  styleUrls: ['view-plan-image.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    NgForOf,
    RouterModule
  ]
})

export class ViewPlanImageComponent implements OnInit {

  constructor(private quoteService: QuoteService, private route: ActivatedRoute, private urlService: UrlService) {

  }

  planId: string;
  planImage: PlanImage;
  plan: Plan;
  previousUrl: string = '';

  ngOnInit() {
    this.urlService.previousUrl$.subscribe((previousUrl: string) => {
      if(previousUrl) {
        this.previousUrl = previousUrl;
      }
    });
    this.planId = this.route.snapshot.paramMap.get('planId');
    this.getPlanImage(this.planId);
    this.getPlanSpec(this.planId);;
  }


  getPlanImage(planId: string) {
    this.quoteService.getPlanImage(planId)
      .subscribe(img => {
        this.planImage = img;
      })
  }

  getPlanSpec(planId: string) {
    this.quoteService.getPlan(this.planId)
      .subscribe(plan => {
        this.plan = plan;
      })
  }
}
